import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import React, { useRef } from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { useToggle } from '@/src/hooks/useToggle';

import DateRangePicker from '../../../../../../common/Elements/DateRangePicker/DateRangePicker';

const DateRangeFilter = ({ dateFilter, onDateFilterChange }) => {
  const buttonRef = useRef();
  const [showOptions, toggleShowOptions] = useToggle(false);

  return (
    <div className={clsx('tw-relative')}>
      <Button
        buttonRef={buttonRef}
        className={clsx('tw-relative', 'tw-flex tw-items-center tw-leading-none', 'tw-mr-0 tw-p-0')}
        onClick={toggleShowOptions}
      >
        <Icon
          icon={ICONS.calendar}
          className={clsx(
            'tw-ml-[5px] tw-text-[16px] tw-text-cfo-black',
            'hover:tw-text-cfo-blue-600',
            showOptions && 'tw-text-cfo-blue-600'
          )}
        />
      </Button>

      <Popper
        open={showOptions}
        anchorEl={buttonRef.current}
        placement="bottom-start"
        style={{ zIndex: 100 }}
      >
        <ClickAwayListener onClickAway={toggleShowOptions}>
          <div>
            <DateRangePicker dates={dateFilter} onSetDates={onDateFilterChange} />
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default DateRangeFilter;
